import React, { useState } from "react";
import { Application, ApplicationService } from "../applications";
import { Payment, ProofOfPaymentForm } from "./";

import { Alert, Button, Col, Form, Row } from "react-bootstrap";

export const ProofOfPayment = () => {
	const [application] = useState(new Application());
	const [payment, setPayment] = useState(new Payment());
	const [applicationFound, setApplicationFound] = useState(false);
	const [existingEmail, setExistingEmail] = useState("");
	const [existingApplicationId, setExistingApplicationId] = useState();
	const [existingError, setExistingError] = useState("");
	const [submitted, setSubmitted] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	const applicationService = new ApplicationService();

	const checkExisting = async () => {
		setExistingError("");
		if (!existingApplicationId) {
			setExistingError("Please enter your application ID.");
			return;
		}

		if (!existingEmail) {
			setExistingError(
				"Please enter the email address you used for your application.",
			);
			return;
		}

		const app = await applicationService.getApplicationByApplicationId(
			String(existingApplicationId),
			existingEmail,
			application,
		);

		if (app) {
			payment.application = application;
			setApplicationFound(true);
		}

		if (app === false) {
			setExistingError(
				"Application could not be found using the information provided.",
			);
		}
	};

	const onSubmit = (pmt: Payment, files?: File[]): void => {
		setSubmitting(true);
		applicationService.submitProofOfPayment(pmt, files).then(() => {
			setSubmitted(true);
			setSubmitting(false);
		});
	};

	let output;
	if (applicationFound && !submitted) {
		output = (
			<ProofOfPaymentForm
				payment={payment}
				onSubmit={onSubmit}
				submitDisabled={submitting}
				showSubmit={true}
			/>
		);
	} else if (submitted) {
		output = (
			<>
				<h3>Payment Submitted</h3>
				<p className="mb-4 mt-4">
					Your proof of payment has been submitted! If you have more
					proof of payment to submit, click the button below.
				</p>
				<Button
					onClick={() => {
						setPayment(new Payment({ application }));
						setSubmitted(false);
					}}
				>
					Submit additional proof of payment
				</Button>
			</>
		);
	} else {
		output = (
			<Row>
				<Col xs={12}>
					<p style={{ fontSize: 20, marginBottom: 20 }}>
						Use this form to submit proof of payment for your
						application. Enter the email address used when filling
						out your application, along with the application id
						provided.
					</p>
				</Col>
				<Col xs={12}>
					<Form.Group controlId="existingApplicationId">
						<Form.Label>Application ID</Form.Label>
						<Form.Control
							size="lg"
							onChange={(event: any) =>
								setExistingApplicationId(event.target.value)
							}
						/>
					</Form.Group>
				</Col>

				<Col xs={12}>
					<Form.Group controlId="existingEmail">
						<Form.Label>Email</Form.Label>
						<Form.Control
							size="lg"
							onChange={(event: any) =>
								setExistingEmail(event.target.value)
							}
						/>
					</Form.Group>

					<Button
						variant="primary"
						size="lg"
						className="float-right btn-next"
						onClick={checkExisting}
					>
						Find Application
					</Button>
				</Col>
			</Row>
		);
	}

	return (
		<div className="container" id="ced-application">
			<div className="stepzilla-well">
				{existingError ? (
					<Alert variant="danger">{existingError}</Alert>
				) : null}
				<h1 className="mb-4">Submit Proof of Payment</h1>
				{output}
			</div>
		</div>
	);
};
